import { render, staticRenderFns } from "./LottoList.vue?vue&type=template&id=1b444ead&scoped=true&"
import script from "./LottoList.vue?vue&type=script&lang=js&"
export * from "./LottoList.vue?vue&type=script&lang=js&"
import style0 from "./LottoList.vue?vue&type=style&index=0&id=1b444ead&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b444ead",
  null
  
)

export default component.exports